import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CalRuleDlyProg } from '../models/calruledlyprog.model';
import { Observable } from 'rxjs';

@Injectable()

export class CalRuleDlyProgService {
  private calruledlyprogUrl: string = 'api/calruledlyprogs';

  constructor(
    private http: HttpClient) { }

  getCalruleDlyProgs(calc_rule_id: number): Observable<CalRuleDlyProg[]> {
    let endpointUrl = `${this.calruledlyprogUrl}/${calc_rule_id}`;
    return this.http.get<CalRuleDlyProg[]>(endpointUrl);
  }

  addCalruleDlyProg(calruleDlyProg): Observable<CalRuleDlyProg> {
    return this.http.post<CalRuleDlyProg>(this.calruledlyprogUrl, calruleDlyProg);
  }

  updateCalruleDlyProg(calruleDlyProg): Observable<CalRuleDlyProg> {
    return this.http.put<CalRuleDlyProg>(this.calruledlyprogUrl, calruleDlyProg);
  }

  deleteCalruleDlyProg(calrule_id: number, dailyProg: number) {
    const params = {
      CalRuleDlyPrg: calrule_id,
      DailyProg: dailyProg
    };
    return this.http.delete(this.calruledlyprogUrl, { params, responseType: 'text' });
  }
  
}
